/**
 * GIWAHS — Adaptive Journey App-Entry Bootstrap (AJIP-16.02.002 · WS2)
 * ---------------------------------------------------------------------
 * Imported once from src/index.js. Executes initAdaptiveJourneys() at
 * module-evaluation time. When JOURNEYS_ENABLED is FALSE the call is a
 * strict no-op — proving isolation.
 */
import {
  initAdaptiveJourneys,
  isAdaptiveJourneysInitialised,
  getPersistenceService,
  getRegistrationService,
  getDiscoveryService,
  getResolutionService,
  getActivationService,
  getBuyerJourneyOrchestrator,
  getSupplierJourneyOrchestrator,
  getFactoryJourneyOrchestrator,
} from './index';

// Fire ignition. Return value is intentionally discarded here — the
// public inspection path is isAdaptiveJourneysInitialised().
initAdaptiveJourneys();

// Regression diagnostic. Read-only booleans. Populated in every mode so
// the regression harness can prove isolation while flags are disabled.
if (typeof window !== 'undefined') {
  Object.defineProperty(window, '__giwahs_adaptive_journeys_initialised__', {
    get: () => isAdaptiveJourneysInitialised(),
    configurable: false,
  });
  Object.defineProperty(window, '__giwahs_journey_persistence_active__', {
    get: () => Boolean(getPersistenceService() && getPersistenceService().enabled),
    configurable: false,
  });
  Object.defineProperty(window, '__giwahs_journey_registration_active__', {
    get: () => Boolean(getRegistrationService() && getRegistrationService().enabled),
    configurable: false,
  });
  Object.defineProperty(window, '__giwahs_journey_discovery_active__', {
    get: () => Boolean(getDiscoveryService() && getDiscoveryService().enabled),
    configurable: false,
  });
  // AJIP-16.02.006 — Resolution & Activation isolation diagnostics.
  Object.defineProperty(window, '__giwahs_journey_resolution_active__', {
    get: () => Boolean(getResolutionService() && getResolutionService().enabled),
    configurable: false,
  });
  Object.defineProperty(window, '__giwahs_journey_activation_active__', {
    get: () => Boolean(getActivationService() && getActivationService().enabled),
    configurable: false,
  });
  // AJIP-16.02.007 — Buyer Journey isolation diagnostic.
  Object.defineProperty(window, '__giwahs_buyer_journey_active__', {
    get: () => Boolean(getBuyerJourneyOrchestrator() && getBuyerJourneyOrchestrator().enabled),
    configurable: false,
  });
  // AJIP-16.02.008 — Supplier Journey isolation diagnostic.
  Object.defineProperty(window, '__giwahs_supplier_journey_active__', {
    get: () => Boolean(getSupplierJourneyOrchestrator() && getSupplierJourneyOrchestrator().enabled),
    configurable: false,
  });
  // AJIP-16.02.009 — Factory Journey isolation diagnostic. Correction 6:
  // follows the established bootstrap isolation pattern and is not an
  // alternative feature-flag mechanism.
  Object.defineProperty(window, '__giwahs_factory_journey_active__', {
    get: () => Boolean(getFactoryJourneyOrchestrator() && getFactoryJourneyOrchestrator().enabled),
    configurable: false,
  });
}
